import type { Locale } from '@silospot/shared';
import { useLocaleStore } from '../stores/locale-store';
import { api } from './api';

/**
 * Change the interface language: switch the live locale + localStorage cache and
 * persist the choice to the signed-in account (kept across sessions and devices).
 * The account write is ignored when unauthenticated (e.g. the pre-login screens).
 */
export function useChangeLocale(): (locale: Locale) => void {
  const setLocale = useLocaleStore((s) => s.setLocale);
  return (locale) => {
    setLocale(locale);
    void api.updateLocale(locale).catch(() => {});
  };
}
